module.exports = __webpack_public_path__ + "static/media/home_grid_item_8.34ad861b.png";